import { sanitizeTokenName } from "./sanitizeTokenName.js";

const STARGATE_ADDRESS = "0x1856C533aC2D94340aAa8544D35a5c1d4A21DeE7".toLowerCase();
const STARGATE_START_TIMESTAMP = new Date("2025-07-01T00:00:00Z").getTime() / 1000;

const TIERS = {
  10000:  'Dawn',
  50000:  'Lightning',
  200000: 'Flash',
  1000000:'Strength',
  5000000:'Thunder',
  15000000:'Mjolnir'
};

/**
 * Liefert ein Objekt mit korrektem Stargate-Label + Flag zurück.
 *
 * @param {Object} nft   – muss mind. { amount, token, timestamp, sender, recipient } enthalten
 * @param {Object} [opts]
 * @param {boolean} [opts.withdrawal]      – true ⇒ _withdrawal, false ⇒ _deposit
 * @param {string}  [opts.walletAddress]   – wenn gesetzt, entscheidet Empfänger-Adresse
 */
export function classifyStargateDeposit(nft, opts = {}) {
  const { withdrawal = false, walletAddress = "" } = opts;

  // Bereits klassifiziert → nur Flag setzen
  if ((nft.classification || "").startsWith("NFT_Stargate_")) {
    return { ...nft, isStargate: true };
  }

  // Nur VET-Transaktionen
  const token = sanitizeTokenName(nft.token);
  if (token !== "VET") return nft;

  // Nur Ganzzahlbeträge, genau definierte Tiers
  const amount = Number(nft.amount);
  if (!Number.isFinite(amount) || !Number.isInteger(amount)) return nft;

  const tier = TIERS[amount];
  if (!tier) return nft;

  // Neue Bedingung: Stargate-Adresse muss beteiligt sein
  const sender = (nft.sender || "").toLowerCase();
  const recipient = (nft.recipient || nft.receiver || "").toLowerCase();
  const involvedWithStargate = sender === STARGATE_ADDRESS || recipient === STARGATE_ADDRESS;
  if (!involvedWithStargate) return nft;

  // Neue Bedingung: Erst ab 01.07.2025
  const ts = Number(nft.timestamp);
  if (!Number.isFinite(ts) || ts < STARGATE_START_TIMESTAMP) return nft;

  // Richtung bestimmen
  let suffix = withdrawal ? "withdrawal" : "deposit";

  if (walletAddress) {
    if (recipient && recipient === walletAddress.toLowerCase()) {
      suffix = "withdrawal";
    }
  }

  return {
    ...nft,
    classification: `NFT_Stargate_${tier}_${suffix}`,
    isStargate: true
  };
}